import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import PropTypes from "prop-types";

const UserCalendar = ({ handleMonthChange, calendarEvents }) => {
  const calendarComponentRef = React.createRef();
  const [theme] = useState("bootstrap");

  return (
    <FullCalendar
      initialView="dayGridMonth"
      headerToolbar={{
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay"
      }}
      plugins={[
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
        bootstrapPlugin
      ]}
      themeSystem={theme}
      ref={calendarComponentRef}
      weekends={true}
      editable={true}
      selectable={true}
      selectMirror={true}
      dayMaxEvents={true}
      events={calendarEvents}
      datesSet={handleMonthChange}
      eventColor="#378006"
    />
  );
};

UserCalendar.propTypes = {
  handleMonthChange: PropTypes.func.isRequired,
  calendarEvents: PropTypes.array.isRequired
};

export default UserCalendar;
